import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getLinkOptionsData } from '@Pages/RetroSynthesis/LinkOption/selectors';
import LinkOption from '@Pages/RetroSynthesis/LinkOption/LinkOption';
import { linkOptionCheckedAction, linkOptionsClearAction, linkOptionsCloseAction } from '@Pages/RetroSynthesis/LinkOption/actions';
import { LinkOptionType } from '@Pages/RetroSynthesis/LinkOption/constants';
import { onStepSelected } from '@Pages/RetroSynthesis/ProjectRoute/analytics';
import { requestParams, routeType as routeTypeSelector } from '@Pages/RetroSynthesis/ProjectRoute/selectors';
import { onAddStepClick, onCopyReaction, onStepDeleteClick } from '@Pages/RetroSynthesis/LinkOption/analytics';
import { getProjectsInfoMap } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { createProjectFromRtStep } from '@Pages/Conditions/ConditionsService';
import { goToCreatedConditionsProject } from '@Pages/Conditions/navigation';
import { trackRtExploreConditionsPopup } from '@Pages/Conditions/analytics';

/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
function LinkOptionContainer({
  projectId,
  routeId,
  step,
  targetRect,
  linkOptionsCloseAction,
  linkOptionCheckedAction,
  linkOptionsClearAction,
  projectsInfoMap,
  routeType,
}) {
  const history = useHistory();
  const [isCreatingConditions, setIsCreatingConditions] = useState(false);
  useEffect(() => {
    linkOptionsClearAction();
  }, []);
  const projectInfo = projectsInfoMap && projectsInfoMap[projectId];

  // Creates a Conditions project from the current RT step, then navigates only
  // after the create succeeds. BE validation errors are shown by the generic flow.
  const handleExploreConditions = async () => {
    if (isCreatingConditions) return;
    trackRtExploreConditionsPopup();
    setIsCreatingConditions(true);
    try {
      const project = await createProjectFromRtStep({ projectId, routeId, step: step.step });
      goToCreatedConditionsProject(history, project);
    } catch (error) {
      Logger.error('LinkOptionContainer explore conditions failed with error:', error);
      setIsCreatingConditions(false);
    }
  };

  const trackAction = ({ optionType, step }) => {
    switch (optionType) {
      case LinkOptionType.SHOW_CONDITIONS:
        onStepSelected({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
        break;
      case LinkOptionType.ADD_REACTION_STEP:
        onAddStepClick({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
        break;
      case LinkOptionType.DELETE_PRIOR_STEPS:
        onStepDeleteClick({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
        break;
      case LinkOptionType.COPY_REACTION:
        onCopyReaction({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
        break;
      default:
        break;
    }
  };

  return (
    <LinkOption
      step={step}
      targetRect={targetRect}
      onClosed={linkOptionsCloseAction}
      onOptionChecked={(optionType) => {
        if (optionType === LinkOptionType.EXPLORE_CONDITIONS) {
          linkOptionsCloseAction();
          handleExploreConditions();
          return;
        }
        linkOptionCheckedAction({ optionType, step, projectId, routeId, projectInfo, routeType });
        trackAction({ optionType, step });
      }}
    />
  );
}

const mapStateToProps = (state) => {
  const { targetRect, step } = getLinkOptionsData(state);
  const { projectId, routeId } = requestParams(state);
  return {
    targetRect,
    step,
    projectId,
    routeId,
    projectsInfoMap: getProjectsInfoMap(state),
    routeType: routeTypeSelector(state),
  };
};

const mapDispatchToProps = {
  linkOptionsCloseAction,
  linkOptionCheckedAction,
  linkOptionsClearAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkOptionContainer);
